// import React from 'react'

// const CmrGrainSampleFeedback = () => {
//   return (
//     <div>CmrGrainSampleFeedback</div>
//   )
// }

// export default CmrGrainSampleFeedback


import React, { useState, useEffect, useRef } from "react";
import DatePicker from 'react-datepicker';
import axios from "axios";
import './CmrGrainSampleFeedback.css'
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select from 'react-select';
import { format, parse } from 'date-fns';
import ExcelJS from 'exceljs';
import pds from './pds.PNG';
const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const CmrGrainSampleFeedback = () => {
    const [godownOptions, setGodownOptions] = useState([]); // Store the fetched FPS options

    const [districtUid, setDistrictUid] = useState("");
    const [subDivisionUid, setSubDivisionUid] = useState(''); // Store subdistrictUid for reports
    const [blockUid, setBlockUid] = useState('');
    const [panchayatUid, setPanchayatUid] = useState('');
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);
    const [fpsId, setFpsId] = useState("");
    const [fpsUniqueId, setFpsUniqueId] = useState("");
    const [fpshops, setFPShops] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const [error, setError] = useState(null);  // Define setError here
    const [isOpen, setIsOpen] = useState(false);
    const [godownId, setGodownId] = useState("");
    const [godownUniqueId, setGodownUniqueId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [sortDirection, setSortDirection] = useState('asc');
    const [showDownloadButton, setShowDownloadButton] = useState(false);  // Control visibility of DOWNLOAD PDF button
    const [showTable, setShowTable] = useState(false);
    const [stockData, setStockData] = useState([]);
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(currentYear, 0, 1); // January 1st of current year

    const modalRef = useRef(null);  // For the modal div
    const modalImageRef = useRef(null);  // For the modal image element
    // const captionRef = useRef(null);  // For the caption element


    const handleSortByDistrict = () => {
        // Toggle sorting direction: if 'asc', change to 'desc' and vice versa
        setSortDirection((prevDirection) => (prevDirection === 'asc' ? 'desc' : 'asc'));
    };
    const generatePDF = () => {
        const doc = new jsPDF({
            unit: 'mm', // units in mm (millimeters)
            format: [280, 350] // A4 size: 210mm x 297mm (you can customize it to larger size like letter: [216, 279])
        });
        doc.setFontSize(18);
        doc.addImage(pds, 'PNG', 9.5, 1, 264, 40);  // Image format: 'PNG'
        const pageWidth = doc.internal.pageSize.width;

        // Set the background color for the title and move it down
        const backgroundYPosition = 40.2; // New y-position for the background fill
        doc.setFillColor(211, 211, 211); // RGB values for 'whitesmoke'
        doc.rect(10, backgroundYPosition, pageWidth - 20, 15, 'F'); // Draw a filled rectangle with the new y-position
        // Set the report title with a styled color
        const title = 'Beneficiary Feedback Report';  // Title for the report
        // Get the page width
        const titleWidth = doc.getTextWidth(title); // Get the width of the title

        // Set title text color to #2a6d8b
        doc.setTextColor(42, 109, 139);  // RGB values for #2a6d8b
        doc.setFontSize(14.4);

        // Increase the y-position to move the title further down
        const titleYPosition = backgroundYPosition + 10; // Adjusted y-position for the title, below the background

        // Draw the title text in the center of the page
        doc.text(title, (pageWidth - titleWidth) / 2, titleYPosition); // Position the title at the new y position

        // Mapping IDs to names for each field
        const district = districts.find(d => String(d.id) === String(districtId));
        const subDivision = subDivisions.find(s => String(s.id) === String(subDivisionId));
        const block = blocks.find(b => String(b.id) === String(blockId));
        const panchayat = panchayats.find(p => String(p.id) === String(panchayatId));
        const fps = Object.values(fpshops).find(f => String(f.id) === String(fpsUniqueId));
        const districtName = district ? district.districtName : '';
        const subDivisionName = subDivision ? subDivision.subDivisionName : '';
        const blockName = block ? block.blockName : '';
        const panchayatName = panchayat ? panchayat.panchayatName : '';
        const fpsName = fps ? fps.godownId : godownUniqueId; // If not found in fpshops, use the typed fpsId

        // console.log(fpsUniqueId);
        // console.log(" fpsId:", fpsUniqueId);

        // Date formatting (if dates are present)
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        // Set the font size and text color for the content
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);  // Set text color to black

        let currentYPosition = 55.21;
        let xPosition = 10;
        const columnSpacing = 86.5; // Space between columns

        // Check if there is data for each table
        const hasDistrict = districtName !== '';
        const hasSubDivision = subDivisionName !== '';
        const hasBlock = blockName !== '';
        const hasPanchayat = panchayatName !== '';
        const hasFps = fpsName !== '';
        const hasFromDate = fromDate !== '';
        const hasToDate = toDate !== '';

        // First Table (District, Sub Division, Block)
        if (hasDistrict || hasSubDivision || hasBlock) {
            // First Table (District, Sub Division, Block)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the first table

            // Set font to normal for labels
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);

            // Add labels only if data exists for the fields
            if (hasDistrict) {
                doc.text("District:", xPosition + 5, currentYPosition + 5);
            }
            if (hasSubDivision) {
                doc.text("Sub Division:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }
            if (hasBlock) {
                doc.text("Block:", xPosition + columnSpacing * 2.02, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Blue color for dynamic data

            // Add dynamic data only if the corresponding field exists
            if (hasDistrict) {
                doc.text(districtName, xPosition + 28, currentYPosition + 5);  // District name (dynamic)
            }
            if (hasSubDivision) {
                doc.text(capitalizeFirstLetter(subDivisionName), xPosition + columnSpacing + 45, currentYPosition + 5);  // Sub Division name (dynamic)
            }
            if (hasBlock) {
                doc.text(blockName, xPosition + columnSpacing * 1.90 + 28, currentYPosition + 5);  // Block name (dynamic)
            }

            currentYPosition += 8;  // Move down for the next row
            // Second Table (Panchayat, FPS ID)
            if (hasPanchayat || hasFps) {
                // Second Table (Panchayat, FPS ID)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

                // Set font to normal for labels (Panchayat, FPS ID)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels only if data exists
                if (hasPanchayat) {
                    doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
                }
                if (hasFps) {
                    doc.text("Godown ID:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }
                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Green color for dynamic data

                // Add dynamic data only if the corresponding field exists
                if (hasPanchayat) {
                    let firstName = panchayatName;
                    doc.text(firstName, xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
                }
                if (hasFps) {
                    doc.text(fpsName, xPosition + columnSpacing + 45, currentYPosition + 5);  // FPS ID (dynamic)
                }
                currentYPosition += 8;  // Move down for the next row
                // If third table has data, show it
                if (hasFromDate || hasToDate) {
                    // Third Table (From Date, To Date)
                    doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                    // Set font to normal for labels (From Date, To Date)
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                    // Add labels for From Date and To Date
                    if (hasFromDate) {
                        doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                    }
                    if (hasToDate) {
                        doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                    }


                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                    // Add dynamic data for From Date and To Date
                    if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                    if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)


                    currentYPosition += 8;  // Move down for the next row
                }
            }
            // If second table has no data, show third table (From Date, To Date)
            else if (!hasPanchayat && !hasFps && (hasFromDate || hasToDate)) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)


                currentYPosition += 8;  // Move down for the next row
            }
        }
        // If the first table has no data, show second table (Panchayat, FPS ID) if it has data
        else if (hasPanchayat || hasFps) {
            // Second Table (Panchayat, FPS ID)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

            // Set font to normal for labels (Panchayat, FPS ID)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels


            // Add labels only if data exists
            if (hasPanchayat) {
                doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
            }
            if (hasFps) {
                doc.text("FPS ID:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Green color for dynamic data
            // Add dynamic data only if the corresponding field exists
            if (hasPanchayat) {
                let firstName = panchayatName;
                doc.text(firstName, xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
            }
            if (hasFps) {
                doc.text(fpsName, xPosition + columnSpacing + 45, currentYPosition + 5);  // FPS ID (dynamic)
            }

            currentYPosition += 8;  // Move down for the next row

            // If third table has data, show it
            if (hasFromDate || hasToDate) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

                currentYPosition += 8;  // Move down for the next row
            }
        }
        // If the second table has no data, show the third table (From Date, To Date)
        else if (hasFromDate || hasToDate) {
            // Third Table (From Date, To Date)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

            // Set font to normal for labels (From Date, To Date)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels for From Date and To Date
            if (hasFromDate) {
                doc.text("From Date:", xPosition + 5, currentYPosition + 5);
            }
            if (hasToDate) {
                doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

            // Add dynamic data for From Date and To Date
            if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
            if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

            currentYPosition += 8;  // Move down for the next row
        }

        currentYPosition += 5;  // Adjust space for next content if needed
        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, pageWidth - 11, currentYPosition + 3, { align: 'right' });


        currentYPosition += 5;  // Adjust space for next content if needed

        // Table Column Titles
        const headers = [
            [
                "S.No",
                "District",
                "SubDivision",
                "Block",
                "Panchayat",
                "Godown ID",
                "Date of Inspection",
                "Officer Name",
                "Society Name",
                "Mill Name",
                "Receipt Date",
                "Lot No",
                "Rice Type",
                "Grain",
                "Grains Quality",
                "Analysis Result"
            ],
        ];

        // Prepare the data for the table
        let rows = [];
        let serialNumber = 1;

        if (sortedStockData && Array.isArray(sortedStockData)) {
            sortedStockData.forEach((data) => {
                const dataRow = [
                    serialNumber++,
                    capitalizeFirstLetter(data.districtName),
                    capitalizeFirstLetter(data.subDivisionName),
                    capitalizeFirstLetter(data.blockName),
                    capitalizeFirstLetter(data.panchayatName),
                    data.godownId || 'N/A',
                    data.startTime ? format(new Date(data.startTime), 'dd-MM-yyyy') : 'N/A',
                    data.officerName || 'N/A',
                    data.societyName || 'N/A',
                    data.millName || 0,
                    data.receiptDate
                        ? format(parse(data.receiptDate, 'dd/MM/yyyy', new Date()), 'dd-MM-yyyy')
                        : 'N/A',
                    data.lotNo || 'N/A',
                    data.grain || 'N/A',
                    data.riceType || 'N/A',
                    data.grainsQuality || 'N/A',
                    data.analysisResult || "N/A",
                ];
                rows.push(dataRow); // Push the prepared row into the rows array
            });
        }

        // AutoTable Plugin - Adding Table to PDF
        doc.autoTable({
            head: headers,
            body: rows,
            startY: currentYPosition,
            theme: 'grid',
            headStyles: {
                fontStyle: 'bold',  // Make the header text bold
                textColor: [12, 92, 108],  // Text color for header
                fillColor: [242, 242, 242],  // Background color for header
                fontSize: 10,
            },
            margin: { top: 30, left: 9 },
            columnStyles: {
                0: { cellWidth: 12, halign: 'center' },
                1: { cellWidth: 16, halign: 'left' },
                2: { cellWidth: 20, halign: 'left' },
                3: { cellWidth: 15, halign: 'left' },
                4: { cellWidth: 15, halign: 'left' },
                5: { cellWidth: 15, halign: 'right' },
                6: { cellWidth: 22, halign: 'right' },
                7: { cellWidth: 15, halign: 'right' },
                8: { cellWidth: 18, halign: 'left' },
                9: { cellWidth: 20, halign: 'right' },
                10: { cellWidth: 15, halign: 'right' },
                11: { cellWidth: 10, halign: 'left' },
                12: { cellWidth: 15, halign: 'left' },
                13: { cellWidth: 15, halign: 'left' },
                14: { cellWidth: 15, halign: 'left' },
                15: { cellWidth: 22, halign: 'left' },

            },
        });

        // Save the PDF
        doc.save("BeneficiaryFeedbackReport.pdf");
    };


    const generateXl = () => {
        const currentDate = new Date();
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Grain Samples Feedback');

        // Title Section
        worksheet.mergeCells('A1:AE1');
        worksheet.getCell('A1').value = `Grain Samples Feedback Report`;
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };
        worksheet.getCell('A1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F5F5F5' } };

        worksheet.mergeCells('A2:AE2');
        worksheet.getCell('A2').value = `Report Date: ${formattedDateTime}`;
        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };
        worksheet.getCell('A2').font = { size: 11, bold: true, color: { argb: '000000' } };
        worksheet.getCell('A2').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F5F5F5' } };

        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear()}` : '';

        worksheet.mergeCells('A3:AE3');
        worksheet.getCell('A3').value = `From Date: ${fromDate}                  To Date: ${toDate}`;
        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A3').font = { size: 11, bold: true, color: { argb: '000000' } };
        worksheet.getCell('A3').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F5F5F5' } };

        // Header Row
        const headers = [
            "S.No",
            "District",
            "SubDivision",
            "Block",
            "Panchayat",
            "Godown ID",
            "Date of Inspection",
            "Officer Name",
            "Society Name",
            "Mill Name",
            "Receipt Date",
            "Lot No",
            "Rice Type",
            "Grain",
            "Grains Quality",
            "No of Samples",
            "Rice Broken Big",
            "Rice Broken Small",
            "Rice Broken Total",
            "Rice Foreign Organic",
            "Rice Foreign In Organic",
            "Rice Foreign Total",
            "Age of Rice",
            "Damaged Grains",
            "Discoloured Rice",
            "Red Rice",
            "Chalky Rice",
            "Dehusk Rice",
            "Moisture Rice",
            "Frk Rice",
            "Analysis Result",

        ];
        worksheet.addRow(headers);

        // Apply Header Styles
        const headerRow = worksheet.getRow(4);
        headerRow.font = { bold: true, size: 12 };
        headerRow.alignment = { horizontal: 'center' };

        headers.forEach((_, colIndex) => {
            const cell = worksheet.getCell(4, colIndex + 1);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }
            };
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        // Adjust Column Widths
        worksheet.columns = [
            { key: 'A', width: 10 }, { key: 'B', width: 20 }, { key: 'C', width: 20 },
            { key: 'D', width: 20 }, { key: 'E', width: 30 }, { key: 'F', width: 20 },
            { key: 'G', width: 30 }, { key: 'H', width: 27 }, { key: 'I', width: 20 },
            { key: 'J', width: 50 }, { key: 'K', width: 20 }, { key: 'L', width: 10 },
            { key: 'M', width: 25 }, { key: 'N', width: 25 }, { key: 'O', width: 25 },
            { key: 'P', width: 35 }, { key: 'Q', width: 35 }, { key: 'R', width: 35 },
            { key: 'S', width: 25 }, { key: 'T', width: 25 }, { key: 'U', width: 25 },
            { key: 'V', width: 25 }, { key: 'W', width: 25 }, { key: 'X', width: 25 },
            { key: 'Y', width: 25 }, { key: 'A', width: 25 }, { key: 'AA', width: 25 },
            { key: 'AB', width: 25 }, { key: 'AC', width: 25 }, { key: 'AD', width: 25 },
            { key: 'AE', width: 25 }, 
        ];

        // Add Data Rows
        let serialNumber = 1;
        if (sortedStockData && Array.isArray(sortedStockData)) {
            sortedStockData.forEach((data) => {
                const dataRow = [
                    serialNumber++,
                    capitalizeFirstLetter(data.districtName),
                    capitalizeFirstLetter(data.subDivisionName),
                    capitalizeFirstLetter(data.blockName),
                    capitalizeFirstLetter(data.panchayatName),
                    data.godownId || 'N/A',
                    data.startTime ? format(new Date(data.startTime), 'dd-MM-yyyy') : 'N/A',
                    data.officerName || 'N/A',
                    data.societyName || 'N/A',
                    data.millName || 0,
                    data.receiptDate
                        ? format(parse(data.receiptDate, 'dd/MM/yyyy', new Date()), 'dd-MM-yyyy')
                        : 'N/A',
                    data.lotNo || 'N/A',
                    data.grain || 'N/A',
                    data.riceType || 'N/A',
                    data.grainsQuality || 'N/A',
                    data.noofSamples|| 'N/A',
                    data.riceBrokenBig|| 'N/A',
                    data.riceBrokenSmall|| 'N/A',
                    data.riceBrokenTotal|| 'N/A',
                    data.riceForeignOrganic|| 'N/A',
                    data.riceForeigninOrganic|| 'N/A',
                    data.riceForeignTotal|| 'N/A',
                    data.ageofRice|| 'N/A',
                    data.damagedGrains|| 'N/A',
                    data.discolouredRice|| 'N/A',
                    data.redRice|| 'N/A',
                    data.chalkyRice|| 'N/A',
                    data.dehuskRice|| 'N/A',
                    data.moistureRice|| 'N/A',
                    data.frkRice|| 'N/A',
                    data.analysisResult || "N/A",
                ];

                const dataRowExcel = worksheet.addRow(dataRow);

                // Adjust alignment for cells based on column
                dataRowExcel.eachCell((cell, colNumber) => {
                    if (colNumber === 1) {
                        cell.alignment = { horizontal: 'center' }; // Serial Number
                    } else if ([6, 7, 11,12,16,17,18,19,20,21,22,24,25,26,27,28,29,30].includes(colNumber)) {
                        cell.alignment = { horizontal: 'right' }; // Numeric fields
                    } else {
                        cell.alignment = { horizontal: 'left' }; // Text fields
                    }
                });
            });
        } else {
            console.warn('sortedStockData is not defined or not an array:', sortedStockData);
        }

        // Save Excel File
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `GrainSamplesFeedbackReport_${formattedDate}.xlsx`;
            link.click();
        }).catch((error) => {
            console.error('Error generating Excel file:', error);
        });
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
        // Set the selected start date
        setEndDate('');           // Clear the end date when start date changes
        setShowCalendar(false);   // Hide the calendar after selection
        setShowTable(false);
    };
    const handleEndDateIconClick = () => {
        // Only show the calendar for endDate if startDate is selected
        if (startDate) {
            setShowEndCalendar(true);
        }
    };
    // Handle the end date change
    const handleEndDateChange = (date) => {
        setEndDate(date);
        setShowEndCalendar(false);
        setShowTable(false);
    };
    // Token you provided (for testing purposes)
    // const token = '7afc6a17404f3b863333e277746c2f1764efa956bbcd6cb2480e276dc7d7e7a3cae7882f9f4414164e9e3b054b14272522b665c7ab8d84c1a41545acdb551446e16d2e19a8d266d032601d2b4a922ed1c0f928bc72967f21f73236fea64230a8bf3832a7765f817231f96721a400a57fd765a4a1d286c6b979183ba68e2a5fa5';
    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    const godownUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;
    useEffect(() => {
        if (token) {
            axios
                .get(`${baseUrl}/districts?pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {

                        setDistricts(response.data.data);
                        const updatedDistricts = [
                            { district: 'All', districtName: 'All Districts', districtUid: null }, // 'All' option
                            ...response.data.data
                        ];

                        setDistricts(updatedDistricts); // Set the updated districts with 'All'
                    } else {
                        setError("Invalid response format");
                    }


                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);

    const fetchSubDivisions = async (districtId) => {
        if (districtId) {
            try {
                const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setSubDivisions(response.data.data || []);
            } catch (error) {
                setError("Error fetching sub-divisions");
            }
        } else {
            setSubDivisions([]);
        }
    };

    const fetchBlocks = async (subDivisionId) => {
        if (subDivisionId) {
            try {
                const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setBlocks(response.data.data || []);
            } catch (error) {
                setError("Error fetching blocks");
            }
        } else {
            setBlocks([]);
        }
    };

    const fetchPanchayats = async (blockId) => {
        if (blockId) {
            try {
                const response = await axios.get(`${baseUrl}/panchayats?filters[block][id][$eq]=${blockId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setPanchayats(response.data.data || []);
            } catch (error) {
                setError("Error fetching panchayats");
            }
        } else {
            setPanchayats([]);
        }
    };
    // const fetchFPShops = async (panchayatId) => {
    //     if (panchayatId) {
    //         try {
    //             const response = await axios.get(`${baseUrl}/villages?filters[panchayat][id][$eq]=${panchayatId}&populate=fairPriceShops&pagination[pageSize]=100`, {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 }
    //             });
    //             const fpsData = response.data.data || [];
    //             const allFps = fpsData.flatMap(item => item.fairPriceShops);
    //             setFPShops(allFps || []);  // Update state with panchayats data
    //             console.log('FPShops:', allFps);  // Debugging the fetched data
    //         } catch (error) {
    //             console.error('Error fetching fpshops:', error);
    //             setError("Error fetching fpshops");
    //         }
    //     } else {
    //         setFPShops([]);  // Reset FP Shops if no Panchayat selected
    //     }
    // };
    const fetchGodownOptions = async () => {
        setIsLoading(true); // Show loading indicator

        // Construct request payload
        const requestData = {};
        requestData.surveyType = "1";
        if (districtUid) {
            requestData.district = districtUid;
        }
        if (subDivisionUid) {
            requestData.subDivision = subDivisionUid;
        }
        if (blockUid) {
            requestData.block = blockUid;
        }
        if (panchayatUid) {
            requestData.panchayat = panchayatUid;
        }
        try {
            const response = await axios.post(`${godownUrl}/get-godown-by-filters`, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data && response.data.data) {
                setGodownOptions(response.data.data); // Set the fetched FPS options
            } else {
                setGodownOptions([]);
                setError("No FPS data found for the selected filters.");
            }
        } catch (error) {
            setError("Error fetching FPS options.");
            console.error('Error fetching FPS options:', error);
        } finally {
            setIsLoading(false); // Hide loading indicator
        }
    };
    useEffect(() => {
        // Fetch FPS options whenever the filters change
        if (districtUid || subDivisionUid || blockUid || panchayatUid) {
            fetchGodownOptions();
        }
    }, [districtUid, subDivisionUid, blockUid, panchayatUid]);
    const handleFpsSelection = (selectedFpsId) => {
        setFpsId(selectedFpsId); // Store the selected FPS ID
    };
    const handleDistrictChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedUId = selectedOption ? selectedOption.districtUid : " N/A";
        // console.log('Selected District:', selectedId); // Debugging the selected district
        //console.log('selected dUid', selectedUId)
        // Reset everything except subdivision
        setDistrictId(selectedId);
        setDistrictUid(selectedUId);  // For report generation
        setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setFpsUniqueId('')
        setSubDivisionId('');  // Reset sub-division
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setGodownId(''); // Reset FPS ID
        setFPShops([]);  // Clear FPS shops
        setPanchayats([])
        setBlocks([])
        setShowTable(false);  // Reset table visibility
        fetchSubDivisions(selectedId);  // Fetch subdivisions based on the selected district
    };

    const handleSubDivisionChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectdSubDivisionUid = selectedOption ? selectedOption.subDivisionUid : "";
        // console.log('Selected Subdivision:', selectedId);
        // console.log('Selected selectdSubDivisionUid:', selectdSubDivisionUid);
        // Reset everything except block
        setSubDivisionUid(selectdSubDivisionUid)
        setSubDivisionId(selectedId);
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setFpsUniqueId('')
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setGodownId('');  // Reset FPS ID
        setFPShops([]);  // Clear FPS shops 
        setPanchayats([])  //it is not actved panchayats without selecting
        setBlocks([]) //it is not actved block  without selecting
        setShowTable(false);  // Reset table visibility
        fetchBlocks(selectedId);  // Fetch blocks based on the selected subdivision
    };

    const handleBlockChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedBlockUid = selectedOption ? selectedOption.blockUid : '';
        // console.log('Selected Block:', selectedId);
        //console.log('Selected BlockUid:', selectedBlockUid);
        // Reset everything except panchayat
        setBlockId(selectedId);
        setBlockUid(selectedBlockUid);
        setPanchayatUid('');  // Clear panchayatUid
        setFpsUniqueId('')
        setPanchayatId('');  // Reset panchayat
        setGodownId(''); // Reset FPS ID
        setFPShops([]);  // Clear FPS shops without selecting
        setPanchayats([])  //it is not actved panchayats  without selecting
        setShowTable(false);  // Reset table visibility
        fetchPanchayats(selectedId);  // Fetch panchayats based on the selected block
    };

    const handlePanchayatChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedpanchayatUid = selectedOption ? selectedOption.panchayatUid : '';
        // console.log('Selected Panchayat:', selectedId);
        //  console.log("selected panUid", selectedpanchayatUid);
        setPanchayatUid(selectedpanchayatUid);
        // Reset only FPS ID, as panchayat is selected
        setPanchayatId(selectedId);
        setFpsUniqueId('')
        setGodownId('');  // Reset FPS ID
        setFPShops([]);  // Clear FPS shops not accepting fps without selecting
        setShowTable(false);  // Reset table visibility
        //  fetchFPShops(selectedId);  // Fetch FPS shops based on the selected panchayat
    };

    const handleFpsId = (selectedOption) => {
        const selectedFpsId = selectedOption ? selectedOption.value : '';
        const selectedFpsUniqueId = selectedOption ? selectedOption.label : '';

        // console.log('Selected FPS:', selectedFpsId);
        // console.log('unique normal ', selectedFpsUniqueId)
        setFpsId(selectedFpsId);  // Save the selected FPS ID
        setFpsUniqueId(selectedFpsUniqueId);  // Save the selected FPS Unique ID
        setShowTable(false);  // Show the table after FPS ID is selected
    };
    const handleGodownId = (selectedOption) => {
        const selectedGodownId = selectedOption ? selectedOption.value : '';
        const selectedGodownUniqueId = selectedOption ? selectedOption.label : '';

        console.log("Selected FPS: ", selectedGodownId);
        console.log('unique normal', selectedGodownUniqueId);
        setGodownId(selectedGodownId);
        setGodownUniqueId(selectedGodownUniqueId);

        setShowTable(false);
    }
    const formatDate = (date) => {
        if (!date) return null;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };
    // Function to clear all data (reset state)
    const handleClear = () => {
        setFpsId('');
        setDistrictUid(null);
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setPanchayatId('');
        setStartDate('');
        setEndDate('');
        setShowDownloadButton(false);
        setShowTable(false);
    };
    const handleGenerateReport = () => {
        if (startDate && endDate && startDate > endDate) {
            setError("Start date cannot be later than end date.");
            alert("Start date cannot be later than end date.");
            return;
        }
        // Start loading
        setIsLoading(true);
        setStockData([]);  // Clear previous stock data
        // Prepare request data
        const requestData = {};
        // Add startDate and endDate to the requestData if available
        if (startDate) {
            requestData.startDate = formatDate(startDate);
        }
        if (endDate) {
            requestData.endDate = formatDate(endDate);
        }
        // Add districtId to the requestData if selected
        // Add districtId to the requestData if selected (only if needed)
        if (districtUid) {
            requestData.districtUid = districtUid;
            requestData.surveyType = "1";
        } else if (!districtUid && !godownId && !godownUniqueId) {
            // If no fpsId and no districtUid, set default as "All"
            requestData.districtUid = "All";
            requestData.surveyType = "1";
        }

        // Add other optional parameters like subDivision, block, panchayat, fpsId
        if (subDivisionUid) {
            requestData.subDivisionUid = subDivisionUid;
        }

        if (blockUid && blockUid.trim() !== "") {
            requestData.blockUid = blockUid;
        }

        if (panchayatUid && panchayatUid.trim() !== "") {
            requestData.panchayatUid = panchayatUid;
        }
        if (godownUniqueId) {
            requestData.godownId = godownUniqueId;  // Use godownUniqueId if it's available
        } else if (godownId) {
            requestData.godownId = godownId;  // Otherwise, use godownId
             requestData.surveyType = "1";
        }
        // console.log(requestData);  // Log the request data for debugging


        //  Make the POST request to fetch the report
        axios
             .post(`${process.env.REACT_APP_API_BASE_URL}/reports/godown-grainSamples-feedback`, requestData, {
           // .post(`http://localhost:8080/reports/godown-grainSamples-feedback`, requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json', // Ensure content type is set
                },
            })
            .then((response) => {
                setIsLoading(false);
                if (response.data && response.data.length > 0) {
                    console.log(response.data);
                    setStockData(response.data);  // Set table data
                    setShowDownloadButton(true); // Show download button
                    setShowTable(true); // Show the table
                } else {
                    setStockData([]); // Clear previous data
                    setError("Loading...");
                    setShowDownloadButton(false); // Hide download button
                    setShowTable(true); // Still show the table even if it's empty
                    // alert("No data available for the selected date range.");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching report.");
                console.error('Error fetching report:', error);
                setShowDownloadButton(false); // Hide download button if there was an error
                setShowTable(true); // Show the table even if there's an error
            });
        setShowTable(true);  // This will show the table
        setShowDownloadButton(true);

    };
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const capitalizeLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.toUpperCase(); // Convert the entire string to uppercase
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };
    const sortData = (data) => {
        return data.sort((a, b) => {
            const districtA = a.districtName || '';
            const districtB = b.districtName || '';
            const subDivisionA = a.subDivisionName || '';
            const subDivisionB = b.subDivisionName || '';
            const blockA = a.blockName || '';
            const blockB = b.blockName || '';
            const panchayatA = a.panchayatName || '';
            const panchayatB = b.panchayatName || '';
            // Sorting order: first district, then sub-division, then block, and finally panchayat
            if (districtA < districtB) return sortDirection === 'asc' ? -1 : 1;
            if (districtA > districtB) return sortDirection === 'asc' ? 1 : -1;
            if (subDivisionA < subDivisionB) return sortDirection === 'asc' ? -1 : 1;
            if (subDivisionA > subDivisionB) return sortDirection === 'asc' ? 1 : -1;
            if (blockA < blockB) return sortDirection === 'asc' ? -1 : 1;
            if (blockA > blockB) return sortDirection === 'asc' ? 1 : -1;
            if (panchayatA < panchayatB) return sortDirection === 'asc' ? -1 : 1;
            if (panchayatA > panchayatB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });
    };
    // Sorted stockData before rendering
    const sortedStockData = sortData(stockData);
    //   const formatDate = (date) => {
    //     if (!date) return '';
    //     const day = String(date.getDate()).padStart(2, '0');
    //     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    //     const year = date.getFullYear();
    //     return `${day}-${month}-${year}`;
    // };


    const getLocalImagePath = (imageUrl) => {
        const externalBaseUrl = "https://parakhfiles.s3.ap-south-1.amazonaws.com"; // Your external base URL
        // const externalBaseUrl = "content://com.app.pdsparakh.provider";
        const localBasePath = "https://d2qyrr1tl2df8g.cloudfront.net"; // Your local folder base path
        if (!imageUrl) return 'No image found';
        if (imageUrl.startsWith(externalBaseUrl)) {
            const relativePath = imageUrl.substring(externalBaseUrl.length);
            const localPath = localBasePath + relativePath;

            return localPath;
        }
        return imageUrl;
    };








    const openModal = (localPath) => {
        if (modalRef.current && modalImageRef.current) {
            modalRef.current.style.display = "block";  // Show the modal
            modalImageRef.current.src = localPath;     // Set the image source
            // captionRef.current.innerHTML = localPath;  // Optionally show a caption
        }
    };

    const closeModal = () => {
        if (modalRef.current) {
            modalRef.current.style.display = "none";
        }
    };

    return (
        <div className="cmr-repo">
            {/* <div className="fpsstockdeviationname">
                    <p>FPS Stock Deviation Report</p>
                </div> */}
            <div className="cmr-1-repo">
                <div className="cmr-card-header-testing-stock-repo">CMR Grain Sample Feedback Report</div>
                <div className='cmr-whole-div'>
                    <div className="cmr-mainBlock-testing-stock-repo">
                        <div className="cmr-group-cu-testing-stock-repo">
                            <label htmlFor="district" className="cmr-date-label">
                                <span className="asterisk">*</span>District
                            </label>
                            <Select
                                className="search-select-BenGo"
                                id="district"
                                // Ensure you pass the selected option as an object with value and label
                                value={districts.find((dist) => dist.id === districtId) ? {
                                    value: districts.find((dist) => dist.id === districtId).id,
                                    label: capitalizeFirstLetter(districts.find((dist) => dist.id === districtId).districtName)
                                } : null}
                                onChange={handleDistrictChange}  // Handle the selection change
                                options={districts
                                    .sort((a, b) => a.districtName.localeCompare(b.districtName))  // Sort by districtName alphabetically
                                    .map((dist) => ({
                                        value: dist.id,
                                        label: capitalizeFirstLetter(dist.districtName),
                                        districtUid: dist.districtUid,

                                    }))
                                }
                                placeholder="Select a district"
                                isSearchable // Enable search in the dropdown
                                styles={customStyles} // Apply custom styles here
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown} // Trigger dropdown open
                                onMenuClose={toggleDropdown} // Trigger dropdown close
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>


                        <div className="cmr-group-cu-testing-stock-repo">
                        <label htmlFor="fpsId">{/*<span className="asterisk">*</span>*/}Godown ID</label>
                            {districtId || districtUid ? (
                                <Select
                                    className="search-select-BenGo"
                                    id="fps"
                                    value={godownId ? {
                                        value: godownId,
                                        label: godownOptions.find((fps) => fps.id === godownId)?.godownId  // Use fpsId for label
                                    } : null}
                                    onChange={handleGodownId}
                                    options={godownOptions

                                        .sort((a, b) => a.godownId.localeCompare(b.godownId))
                                        .map((fps) => ({
                                            value: fps.id,
                                            label: fps.godownId,
                                            godownUniqueId: fps.godownUniqueId,
                                        }))
                                    }

                                    placeholder="Select Godown Shop"
                                    isSearchable
                                    styles={customStyles}
                                    required
                                    isOpen={isOpen}
                                    onMenuOpen={toggleDropdown}
                                    onMenuClose={toggleDropdown}
                                    components={{
                                        DropdownIndicator: () => (
                                            <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                <img
                                                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                    alt="Dropdown"
                                                    style={{ width: '20px', height: '20px' }}
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            ) : (
                                <input className="search-select-BenGo-1"
                                    type="text"
                                    placeholder="Enter Godown ID"
                                    value={godownId}
                                    onChange={(e) => setGodownId(e.target.value)}
                                // style={{ padding: '5px' }}
                                />
                            )}

                        </div>

                        <div className="cmr-group-cu-testing-2-stock-repo-get-clear">
                            <div className="cmr-group-cu-button">
                                <button className="cmr-btn-test-stock-repo" onClick={handleClear}
                                    disabled={
                                        // Button is disabled if no districtId or fpsId is provided AND no startDate and endDate are provided
                                        !(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))
                                    }
                                >CLEAR
                                </button>
                            </div>
                            <div className="cmr-group-cu-button">
                                <button
                                    className="cmr-btn-test-stock-repo"
                                    onClick={handleGenerateReport}
                                    disabled={
                                        // Button is disabled if no districtId or fpsId is provided AND no startDate and endDate are provided
                                        !(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))
                                    }  // Disable if any field is not selected
                                >
                                    GENERATE REPORT
                                </button>
                            </div>

                        </div>

                    </div>

                    

                    <div className="cmr-mainBlock-testing-2-stock-repo">
                        <div className="cmr-group-cu-testing-2-stock-repo">
                            <label htmlFor="startDate" className="cmr-date-label"><span className="asterisk">*</span>From Date</label>
                            <div className="cmr-setting-stock-repo">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="cmr-input-repo"
                                    value={startDate ? format(startDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowCalendar(true)}
                                />
                                <div className="cmr-icon-test-stock-repo" onClick={() => setShowCalendar(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showCalendar && (
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        onClickOutside={() => setShowCalendar(false)}
                                        inline
                                        minDate={minStartDate} // From January 1st of current year
                                        maxDate={currentDate} // Today
                                    />
                                )}
                            </div>
                        </div>

                        <div className="cmr-group-cu-testing-2-stock-repo">
                            <label htmlFor="startDate" className="cmr-date-label"><span className="asterisk">*</span>To Date</label>
                            <div className="cmr-setting-stock-repo">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="cmr-input-repo"
                                    value={endDate ? format(endDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowEndCalendar(true)}
                                    disabled={!startDate}

                                />
                                <div className="cmr-icon-test-stock-repo" onClick={handleEndDateIconClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showEndCalendar && (
                                    <DatePicker
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        // onChange={(date) => {
                                        //     setEndDate(date);
                                        //     setShowEndCalendar(false);
                                        // }}
                                        onClickOutside={() => setShowEndCalendar(false)}
                                        minDate={startDate} // End date can't be before the start date
                                        maxDate={currentDate} // End date can't be after 
                                        inline
                                    />
                                )}
                            </div>
                        </div>

                        {/* <div className="beneficiary-group-cu-testing-2-stock-repo-btn"> */}
                        {/* Conditionally Render DOWNLOAD PDF Button */}

                        {/* Conditionally Render DOWNLOAD PDF & DOWNLOAD XLSX Buttons */}
                        <div className="cmr-group-cu-testing-2-stock-repo-pdf-xl">
                            {(fpsId || (districtUid && startDate && endDate) || (districtUid === null && startDate && endDate)) && showDownloadButton && showTable && (
                                <div className="cmr-group-cu-button-container">
                                    {/* DOWNLOAD PDF Button */}
                                    {/* <div className="cmr-group-cu-button">
                                        <button onClick={generatePDF} className="cmr-btn-test-stock-repo-d">
                                            DOWNLOAD PDF
                                        </button>
                                    </div> */}

                                    {/* DOWNLOAD XLSX Button */}
                                    <div className="cmr-group-cu-button-xl">
                                        <button onClick={generateXl} className="cmr-btn-test-stock-repo-d">
                                            DOWNLOAD XLSX
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>


                        {/* </div> */}

                    </div>
                </div>
            </div>

            <div className="cmr-main-repo">
                <table className="cmr-table-repo">
                    <thead>
                        <tr>
                            <th >S.No.</th>
                            <th

                                onClick={handleSortByDistrict}
                                style={{ cursor: 'pointer' }}
                            >
                                District {sortDirection === 'asc' ? '' : ''}
                            </th>
                            <th >Sub Division</th>
                            <th >Block</th>
                            <th >Panchayat</th>
                            <th>Godown ID</th>
                            {/* <th rowSpan="2">Godown Name</th> */}
                            <th>Date of Inspection</th>
                            <th >Officer Name</th>
                            <th >Society Name</th>
                            <th >Mill Name</th>
                            <th>Receipt Date</th>
                            <th>Lot No</th>

                            <th >Rice Type</th>
                            <th>Grain</th>
                            <th>Grains Quality</th>
                            {/* <th>Grains Photo</th>
                            <th> No of Samples</th>
                            <th>Rice Broken Big</th>
                            <th>Rice Broken Small</th>
                            <th>Rice Broken Total</th>
                            <th>Rice Foreign Organic</th>
                            <th>Rice Foreign In Organic</th>
                            <th>Rice Foreign Total</th>
                            <th>Age of Rice</th>
                            <th>Damaged Grains</th>
                            <th>Discoloured Rice</th>
                            <th>Red Rice</th>
                            <th>Chalky Rice</th>
                            <th>Dehusk Rice</th>
                            <th>Moisture Rice</th>
                            <th>Frk Rice</th> */}
                            <th>Analysis Result</th>
                            {/* <th>Analysis Photo</th> */}
                            {/* <th rowSpan="2">Quality of Grain Distributed </th>
                            <th rowSpan="2">Quantity of Grain Distributed </th>
                            <th rowSpan="2">Distributed Receipt Provided</th> */}
                        </tr>
                    </thead>
                    {showTable && (
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="14" style={{ textAlign: 'center', padding: '10px' }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) : sortedStockData.length > 0 ? (
                                sortedStockData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{capitalizeFirstLetter(data.districtName)}</td>
                                        <td>{capitalizeFirstLetter(data.subDivisionName)}</td>
                                        <td>{capitalizeFirstLetter(data.blockName)}</td>
                                        <td>{capitalizeFirstLetter(data.panchayatName)}</td>
                                        <td>{data.godownId}</td>
                                        <td>{format(new Date(data.startTime), 'dd-MM-yyyy')}</td>
                                        <td>{data.officerName || 'N/A'}</td>
                                        <td>{data.societyName || 'N/A'}</td>
                                        <td>{data.millName || 'N/A'}</td>
                                        <td>
                                            {data.receiptDate
                                                ? format(parse(data.receiptDate, 'dd/MM/yyyy', new Date()), 'dd-MM-yyyy')
                                                : 'N/A'}
                                        </td>

                                        <td>{data.lotNo|| 'N/A'}</td>
                                        <td>{data.grain|| 'N/A'}</td>
                                        <td>{data.riceType|| 'N/A'}</td>
                                        <td>{data.grainsQuality|| 'N/A'}</td>
                                        {/* <td>{data.grainsPhoto}</td> */}
                                        {/* <td>
                                            {data.grainsPhoto && data.grainsPhoto.startsWith("content://") ? (
                                                <span><img src={getLocalImagePath(data.grainsPhoto)}
                                                    alt="Analysis" /></span>
                                            ) : (
                                                <img
                                                    src={getLocalImagePath(data.grainsPhoto)}
                                                    alt="Analysis"
                                                    style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                                    onClick={() => openModal(getLocalImagePath(data.grainsPhoto))}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.style.display = 'none';
                                                        e.target.parentNode.textContent = 'No image available';
                                                    }}
                                                />
                                            )}
                                        </td> */}
                                        {/* <td>{data.noofSamples}</td>
                                        <td>{data.riceBrokenBig}</td>
                                        <td>{data.riceBrokenSmall}</td>
                                        <td>{data.riceBrokenTotal}</td>
                                        <td>{data.riceForeignOrganic}</td>
                                        <td>{data.riceForeigninOrganic}</td>
                                        <td>{data.riceForeignTotal}</td>
                                        <td>{data.ageofRice}</td>
                                        <td>{data.damagedGrains}</td>
                                        <td>{data.discolouredRice}</td>
                                        <td>{data.redRice}</td>
                                        <td>{data.chalkyRice}</td>
                                        <td>{data.dehuskRice}</td>
                                        <td>{data.moistureRice}</td>
                                        <td>{data.frkRice}</td>*/}
                                        <td>{data.analysisResult|| 'N/A'}</td>
                                        {/* <td>{data.analysisPhoto}</td> */}


                                        {/* <td>
                                            {data.analysisPhoto && data.analysisPhoto.startsWith("content://") ? (
                                                <span><img src={getLocalImagePath(data.analysisPhoto)}
                                                    alt="Analysis" /></span>
                                            ) : (
                                                <img
                                                    src={getLocalImagePath(data.analysisPhoto)}
                                                    alt="Analysis"
                                                    style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                                    onClick={() => openModal(getLocalImagePath(data.analysisPhoto))}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.style.display = 'none';
                                                        e.target.parentNode.textContent = 'No image available';
                                                    }}
                                                />
                                            )}
                                        </td> */}
                                        <div id="imageModal" className="modal-cmr" ref={modalRef}>
                                            <span className="close-cmr" onClick={closeModal}>&times;</span>
                                            <img className="modal-content-cmr" ref={modalImageRef} />
                                            {/* <div id="caption" ref={captionRef}></div> */}
                                        </div>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="14" style={{ textAlign: 'center', color: 'red', padding: '10px' }}>
                                        No Data Available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}

                </table>


            </div>

        </div>
    );

}
export default CmrGrainSampleFeedback;